<template>
  <v-menu
    v-if="shouldShowMenu"
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list
        color="transparent"
        dense
        nav
        class="user-profile-activator-list py-0"
      >
        <v-list-item
          class="user-profile-activator px-0"
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-avatar class="my-0">
            <v-avatar
              size="40px"
              color="primary"
              class="v-avatar-light-bg primary--text"
            >
              <v-icon color="primary" size="40">
                {{ icons.mdiInformation }}
              </v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content class="user-profile-activator__info d-none d-sm-block py-0">
            <v-list-item-subtitle class="text-caption">
              {{ activatorLabel }}
            </v-list-item-subtitle>
            <v-list-item-title class="text-overline">
              {{ activatorValue }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action
            class="user-profile-activator__logout d-none d-sm-flex"
            @click.stop="logoutUser"
          >
            <v-btn
              icon
              large
            >
              <v-icon>{{ icons.mdiLogout }}</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </template>
    <v-list>
      <v-list-item
        v-if="isSalesperson"
        three-line
        style="height: auto"
      >
        <v-list-item-avatar tile>
          <v-icon size="30">
            {{ icons.mdiAccountVoice }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>Oturumu Açan</v-list-item-subtitle>
          <v-list-item-title class="text-body-2 font-weight-medium mt-1">
            {{ sessionOpenerName }}
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="activeCustomerId"
            class="text-caption"
          >
            Aktif Müşteri : {{ activeCustomerId }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="isSalesperson && userDetail"></v-divider>

      <template v-if="userDetail">
        <v-list-item three-line style="height: auto">
          <v-list-item-avatar tile>
            <v-icon size="30">
              {{ icons.mdiDomain }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle>Şirket</v-list-item-subtitle>
            <v-list-item-title class="text-body-2 font-weight-medium mt-1">
              {{ userDetail.company }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption"> Müşteri Kodu : {{ activeCustomerId || userData.customer_id }} </v-list-item-subtitle>
            <v-list-item-subtitle class="text-caption">
              {{ userDetail.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item three-line style="height: auto">
          <v-list-item-avatar tile>
            <v-icon size="30">
              {{ icons.mdiAccountVoice }}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle>Satış Temsilcisi</v-list-item-subtitle>
            <v-list-item-title class="text-body-2 font-weight-medium mt-1">
              {{ userDetail.sales_person }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption">
              {{ userDetail.sales_person_email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item three-line style="height: auto">
          <v-list-item-avatar tile>
            <v-icon size="30">
              {{ icons.mdiDomain }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle>Profil No</v-list-item-subtitle>
            <v-list-item-title class="text-body-2 font-weight-medium mt-1">
              {{ userData.profile }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item three-line style="height: auto">
          <v-list-item-avatar tile>
            <v-icon size="30">
              {{ icons.mdiMapMarker }}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-subtitle>Konum</v-list-item-subtitle>
            <v-list-item-title class="text-body-2 font-weight-medium mt-1">
              {{ userDetail.city }} / {{ userDetail.state }} - {{ userDetail.country }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption"> Ofis Kodu : {{ userDetail.office_code }} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </template>

      <v-list-item
        v-else-if="!isSalesperson"
        disabled
      >
        <v-list-item-content>
          <v-list-item-title class="text-caption">
            Profil bilgileri yükleniyor...
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Logout -->
      <v-list-item
        three-line
        style="height: auto"
        @click="logoutUser"
      >
        <v-list-item-avatar tile>
          <v-icon size="30">
            {{ icons.mdiLogout }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Çıkış Yap</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { initialAbility } from '@/plugins/acl/config'
import store from '@/store'
import { useOrderStore } from '@/stores/order'
import { clearSession } from '@/utils/session'
import { getUserData } from '@/utils/userData'
import axios from '@axios'
import { useRouter } from '@core/utils'
import {
  mdiAccountVoice,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiDomain,
  mdiHelpCircleOutline,
  mdiInformation,
  mdiLogout,
  mdiMapMarker,
} from '@mdi/js'
import { computed, getCurrentInstance, onMounted, ref, watch } from '@vue/composition-api'

export default {
  setup() {
    const vm = getCurrentInstance().proxy
    const { router } = useRouter()
    const userData = getUserData()
    const order = useOrderStore()

    const isSalesperson = computed(() => ['30', '110'].includes(String(userData.profile)))
    const activeCustomerId = computed(() => {
      if (isSalesperson.value) {
        return store.state.plasiyerCustomer || null
      }

      return userData.customer_id || null
    })
    const shouldShowMenu = computed(() => Boolean(
      localStorage.getItem('accessToken') && (userData.customer_id || isSalesperson.value),
    ))
    const sessionOpenerName = computed(() => (
      userData.username
      || userData.uname
      || userData.sales_person
      || userData.company
      || 'Satışçı'
    ))
    const activatorLabel = 'Kullanıcı Adı'
    const activatorValue = computed(() => (
      userData.uname || sessionOpenerName.value
    ))

    const logoutUser = () => {
      clearSession()
      order.rawItems = []
      store.commit('PLASIYER_CUSTOMER', null)
      vm.$ability.update(initialAbility)
      router.push({ name: 'auth-login' })
    }

    const userDetail = ref(null)

    const fetchUserDetail = () => {
      const params = new URLSearchParams()
      params.append('method', 'getCustomerDetail')
      axios
        .post('', params)
        .then(response => {
          if (response.data.error) {
            if (!isSalesperson.value) {
              logoutUser()
            }

            return
          }
          userDetail.value = response.data.detail
        })
        .catch(e => {
          // Sunucu tarafı geçici hata (geçersiz yanıt) oturumu düşürmemeli
          if (!isSalesperson.value && !e?.isInvalidResponse) {
            logoutUser()
          }
        })
    }

    onMounted(() => {
      fetchUserDetail()
    })

    watch(
      () => store.state.plasiyerCustomer,
      newValue => {
        if (!isSalesperson.value) {
          return
        }

        if (!newValue) {
          userDetail.value = null

          return
        }

        fetchUserDetail()
      },
    )

    return {
      logoutUser,
      userData,
      userDetail,
      isSalesperson,
      activeCustomerId,
      shouldShowMenu,
      sessionOpenerName,
      activatorLabel,
      activatorValue,
      icons: {
        mdiInformation,
        mdiDomain,
        mdiAccountVoice,
        mdiMapMarker,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogout,
      },
    }
  },
}
</script>

<style lang="scss">
.user-profile-activator-list {
  background: transparent !important;
}

.user-profile-activator {
  min-height: 48px !important;
}

.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
